import { render, staticRenderFns } from "./PageLearnerVideoConference.vue?vue&type=template&id=2d271480&scoped=true&"
import script from "./PageLearnerVideoConference.vue?vue&type=script&lang=js&"
export * from "./PageLearnerVideoConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d271480",
  null
  
)

export default component.exports